module.exports = __webpack_public_path__ + "static/media/DSC_0234.206b43ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0234.jpg
// module id = 570
// module chunks = 0